module.exports = __webpack_public_path__ + "static/media/entity-relationship.d3998e4c.svg";